/* ==========================================================================
   LEBONFLACON — Panier premium (v2)
   Comportements additifs : toggle code promo, ajout 1-clic du bloc
   "Complétez votre commande". S'appuie sur /cart/add.js natif Shopify ;
   cart-progress-bar.js (chargé avant ce fichier) intercepte déjà fetch()
   vers /cart/add et rafraîchit automatiquement la barre de progression.
   v2 : le clic "Ajouter" du bloc upsell recharge la page après l'ajout
   (au lieu de se contenter de mettre à jour la pastille du panier) pour
   que la ligne ajoutée et son prix remisé (-10%) s'affichent immédiatement,
   sans quoi le panier affichait le prix plein tant que le client ne
   rafraîchissait pas manuellement la page.
   ========================================================================== */
(function () {
  'use strict';

  // ---- Toggle "Vous avez un code promo ?" ----

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.lbf-promo-toggle');
    if (!toggle) return;
    e.preventDefault();
    var field = document.querySelector(toggle.getAttribute('data-target'));
    if (!field) return;
    var isHidden = field.hasAttribute('hidden');
    if (isHidden) {
      field.removeAttribute('hidden');
      var input = field.querySelector('input[name="discount"]');
      if (input) input.focus();
    } else {
      field.setAttribute('hidden', 'hidden');
    }
  });

  // ---- Compte à rebours "expédition aujourd'hui avant 17h" ----

  (function initShippingCountdown() {
    var el = document.querySelector('[data-lbf-countdown]');
    if (!el) return;
    var remaining = parseInt(el.getAttribute('data-lbf-countdown'), 10);
    if (isNaN(remaining) || remaining <= 0) return;
    var textEl = el.querySelector('[data-lbf-countdown-text]');
    if (!textEl) return;

    var timer = setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        clearInterval(timer);
        return;
      }
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      textEl.innerHTML = h + '&nbsp;h&nbsp;' + m;
    }, 1000);
  })();

  // ---- Pulse du sous-total quand le panier change ----

  (function initSubtotalPulse() {
    var subtotalEl = document.querySelector('.cart-subtotal');
    var priceEl = document.getElementById('bk-cart-subtotal-price');
    if (!subtotalEl || !priceEl || !window.MutationObserver) return;

    var pulseTimer = null;
    var observer = new MutationObserver(function () {
      subtotalEl.classList.add('lbf-pulse');
      if (pulseTimer) clearTimeout(pulseTimer);
      pulseTimer = setTimeout(function () {
        subtotalEl.classList.remove('lbf-pulse');
      }, 500);
    });
    observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
  })();

  // ---- Sélecteur de quantité premium (-/+) ----

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lbf-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var input = document.getElementById(btn.getAttribute('data-target'));
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-lbf-qty-step'), 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---- Ajout 1-clic "Complétez votre commande" ----
  // Recharge la page après un ajout réussi : c'est la seule façon fiable
  // d'afficher la ligne ajoutée avec son prix -10% et le sous-total à jour
  // (ni cette page ni cart-progress-bar.js ne réécrivent la liste d'articles
  // ou le sous-total au format HTML, seule la barre de progression l'est).

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lbf-cart-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add_failed');
        btn.textContent = 'Ajouté ✓';
        window.location.reload();
      })
      .catch(function () {
        btn.textContent = originalLabel;
        btn.disabled = false;
      });
  });

  // ---- Recentrage JS du méga-menu "BOUTIQUE" sur le vrai centre de l'écran ----
  // nav-premium.css centre le panneau avec `left: 50vw` + `transform:
  // translateX(-50%)`, une astuce qui suppose que le panneau se positionne
  // par rapport au viewport. En réalité son bloc de référence (containing
  // block) est le <li> lui-même (règle .site-nav li { position: relative }
  // dans theme.css) : le panneau se décale donc vers la droite d'une
  // distance égale à la position réelle du <li> "BOUTIQUE" dans la barre de
  // navigation, au lieu d'être centré sur l'écran — plus la fenêtre est
  // large, plus le décalage est visible, et les colonnes de droite du
  // panneau finissent hors écran. Corrigé en recalculant "left" en pixels
  // (au lieu du hack en vw) au chargement, au redimensionnement et à
  // l'ouverture du menu, pour que le panneau reste toujours centré sur le
  // vrai centre de l'écran quelle que soit la position du <li>. Uniquement
  // à partir de 750px (breakpoint desktop du panneau dans nav-premium.css) ;
  // l'accordéon mobile n'est pas concerné.

  (function initMegaMenuCentering() {
    function centerDropdown(li) {
      var dropdown = li.querySelector(':scope > .site-nav--dropdown');
      if (!dropdown) return;
      var liRect = li.getBoundingClientRect();
      var offset = window.innerWidth / 2 - liRect.left;
      dropdown.style.setProperty('left', offset + 'px', 'important');
    }

    function centerAll() {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      var items = document.querySelectorAll('.site-nav-first-level.site-nav--has-dropdown');
      for (var i = 0; i < items.length; i++) {
        centerDropdown(items[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', centerAll);
    } else {
      centerAll();
    }
    window.addEventListener('load', centerAll);
    window.addEventListener('resize', centerAll);

    var dropdownItems = document.querySelectorAll('.site-nav-first-level.site-nav--has-dropdown');
    for (var j = 0; j < dropdownItems.length; j++) {
      dropdownItems[j].addEventListener('mouseenter', function () {
        centerDropdown(this);
      });
    }
  })();

  // ---- Empeche le tactile de refermer le mega-menu au moindre scroll ----
  // Cause reelle du bug "sur tablette, scroller dans Boutique/Fidelite
  // referme le panneau" : theme.js (timber.accessibleNav) ouvre le panneau
  // en lui ajoutant la classe "nav-hover" (au survol/tap), puis attache 250ms
  // plus tard un listener touchstart sur TOUT le <body> qui retire cette
  // classe — donc referme le panneau — au tout premier contact tactile,
  // sans distinguer un tap "en dehors" du panneau d'un simple geste de
  // scroll. Sur tablette, poser le doigt pour faire defiler la page (que ce
  // soit a l'interieur du panneau ouvert ou en dessous) declenche ce
  // touchstart et referme "Boutique"/"Fidelite" avant meme que le scroll ne
  // commence.
  // Corrige en interceptant le touchstart en phase de capture sur
  // "document" — donc avant que le listener de theme.js, pose en phase de
  // bulle sur "body", ne le recoive — et en stoppant sa propagation tant
  // qu'un panneau est ouvert. On reimplemente nous-memes la fermeture,
  // uniquement sur un vrai tap en dehors du panneau (touchend sans
  // deplacement notable du doigt), jamais sur un geste de scroll (detecte
  // via touchmove). Ne change rien quand aucun panneau n'est ouvert, ni sur
  // desktop (souris).

  (function initMegaMenuTouchScrollFix() {
    var startX = 0;
    var startY = 0;
    var moved = false;

    function openItem() {
      return document.querySelector('.site-nav-first-level.site-nav--has-dropdown.nav-hover');
    }

    document.addEventListener(
      'touchstart',
      function (e) {
        var item = openItem();
        if (!item) return;
        e.stopPropagation();
        var t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        moved = false;
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        var item = openItem();
        if (!item) return;
        var t = e.touches[0];
        if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) {
          moved = true;
        }
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'touchend',
      function (e) {
        var item = openItem();
        if (!item) return;
        e.stopPropagation();
        if (moved) return;
        if (!item.contains(e.target)) {
          item.classList.remove('nav-hover');
        }
      },
      { capture: true, passive: true }
    );
  })();

  // ---- Tap sur "BOUTIQUE"/"FIDELITE" : toggle ouverture/fermeture fiable ----
  // v1 de ce correctif s'appuyait sur le mouseenter synthetique du navigateur
  // (theme.js : showDropdown ajoute "nav-hover") pour l'OUVERTURE, et ne
  // gerait nous-memes que la FERMETURE au second tap. Mais la plupart des
  // navigateurs ne redeclenchent PAS ce mouseenter synthetique tant que le
  // pointeur simule ne "quitte" pas l'element entre deux taps : en tapant
  // 2 fois de suite le meme bouton, seul le tout premier tap produit un
  // mouseenter (vraie transition survol) ; le second (et tous les suivants)
  // n'en produit plus, puisque du point de vue du navigateur le pointeur
  // n'a jamais cesse de "survoler" ce lien entre les deux taps. Resultat :
  // apres une fermeture faite par nous (tap 2), un troisieme tap ne
  // declenchait plus aucun mouseenter pour rouvrir le panneau via theme.js,
  // et notre propre logique ne faisait alors que la fermeture -> le menu
  // restait bloque ferme.
  // Corrige en prenant nous-memes l'entiere responsabilite du toggle,
  // sans dependre du mouseenter natif : au touchstart sur le lien, on note
  // l'etat AVANT ce tap (ouvert ou ferme) ; au click qui termine ce meme
  // tap (identifie via le meme <li>), on force l'etat oppose (ferme -> on
  // ajoute nav-hover nous-memes ; ouvert -> on le retire). Un clic qui ne
  // vient pas d'un tap tactile qu'on vient de suivre (ex. vrai clic souris
  // sur desktop, sans touchstart prealable sur ce meme lien) n'est pas
  // intercepte : le comportement natif au survol reste inchange.

  (function initMegaMenuTapToggle() {
    var pendingLi = null;
    var pendingWasOpen = false;

    document.addEventListener(
      'touchstart',
      function (e) {
        var link = e.target.closest && e.target.closest('.site-nav-first-level.site-nav--has-dropdown > a');
        if (!link) {
          pendingLi = null;
          return;
        }
        pendingLi = link.parentElement;
        pendingWasOpen = pendingLi.classList.contains('nav-hover');
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest && e.target.closest('.site-nav-first-level.site-nav--has-dropdown > a');
        if (!link) return;
        var li = link.parentElement;
        if (pendingLi !== li) return;
        e.preventDefault();
        if (pendingWasOpen) {
          li.classList.remove('nav-hover');
        } else {
          li.classList.add('nav-hover');
        }
        pendingLi = null;
      },
      true
    );
  })();
})();
